import { Injectable } from '@angular/core';

import { Store, select } from '@ngrx/store';

import { LocaleState } from '../../redux/state';
import { selectLocaleState } from '../../redux/selectors';

/**
 * Minimal shim for TranslateService from @ngx-translate/core
 */
interface MinimalTranslateService {
  use(locale: string);
}

/**
 * Minimal shim for LanguageService from @uxdf/direct-shared-lib
 */
interface MinimalLanguageService {
  setLanguage(lang: string);
}

@Injectable({
  providedIn: 'root'
})
/**
 * Service to register the instances of relevant services in a Feature Module.
 */
export class LocaleWatcherService {
  constructor(private readonly store: Store<LocaleState>) {}

  startWatch(ngxTranslater?: MinimalTranslateService, dslLanguageService?: MinimalLanguageService) {
    this.store.pipe(select(selectLocaleState)).subscribe(({ currentBcpLocale: newLocale }) => {
      if (ngxTranslater && ngxTranslater.use) {
        ngxTranslater.use(newLocale);
      }
      if (dslLanguageService && dslLanguageService.setLanguage) {
        dslLanguageService.setLanguage(newLocale);
      }
    });
  }
}
